import { useEffect, useState } from 'react';

/**
 * Which section is the reader in? Uses scroll position directly (rather than an
 * IntersectionObserver) so the top of the page and the very bottom behave.
 */
export default function useActiveSection(ids) {
  const [active, setActive] = useState(null);
  const key = ids.join('|');

  useEffect(() => {
    let raf = 0;
    const update = () => {
      raf = 0;
      const y = window.scrollY;
      const doc = document.documentElement;
      if (y < 120) return setActive(null);
      if (window.innerHeight + y >= doc.scrollHeight - 4) return setActive(ids[ids.length - 1]);
      const line = 72 + window.innerHeight * 0.3;
      let current = null;
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= line) current = id;
      });
      return setActive(current);
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return active;
}
